import * as moment from "moment";

import { ClientScheduleType } from "utils/transformApiSchedule";

import { START_OF_MONTH } from "./utils";

interface ScheduleType
  extends Pick<ClientScheduleType, "firstPaymentDay" | "secondPaymentDay"> {
  fallback?: Date[];
}

export default function twiceMonthlySampleDates(
  schedule: ScheduleType,
): Date[] {
  const defaultFallback = [
    moment(START_OF_MONTH).toDate(),
    moment(START_OF_MONTH)
      .add({ weeks: 2 })
      .toDate(),
  ];

  const {
    fallback = defaultFallback,
    firstPaymentDay,
    secondPaymentDay,
  } = schedule;

  const dates = [];

  if (!firstPaymentDay && !secondPaymentDay) return fallback;

  const currentDayNum = moment().date();

  if (firstPaymentDay) {
    const firstPaymentDayInt = parseInt(firstPaymentDay, 10);

    const firstPaymentDate =
      firstPaymentDayInt < currentDayNum
        ? moment()
            .add({ month: 1 })
            .date(firstPaymentDayInt)
        : moment().date(firstPaymentDayInt);

    dates.push(firstPaymentDate);
  }

  if (secondPaymentDay) {
    const secondPaymentDayInt = parseInt(secondPaymentDay, 10);

    const secondPaymentDate =
      secondPaymentDayInt < currentDayNum
        ? moment()
            .add({ month: 1 })
            .date(secondPaymentDayInt)
        : moment().date(secondPaymentDayInt);

    dates.push(secondPaymentDate);
  }

  return dates
    .sort((a, b) => {
      if (a.isBefore(b, "day")) return -1;
      if (a.isSame(b, "day")) return 0;
      if (a.isAfter(b, "day")) return 1;
    })
    .map(date => date.toDate());
}
